import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "../components/LandingPage.vue";
import GTSelect from "../components/GTSelect.vue";
import GTList from "../components/GTProjectList.vue";
import GTDesigner from "../components/GTDesigner";
import Wizard from "../components/wizard/WizardLandingPage.vue";
import WizardFinal from "../components/wizard/WizardFinal.vue";
import store from "../store";

const routes = [
  { path: "/", component: LandingPage },
  { path: "/select", component: GTSelect },
  { path: "/list", component: GTList },
  { path: "/editor", component: GTDesigner, beforeEnter: checkInlay },
  { path: "/project", component: GTList },
  { path: "/:pathMatch(.*)", component: LandingPage },
  // {
  //   path: "/wizard",
  //   component: Wizard,
  // },
  // { path: "/wizard/absenden", component: WizardFinal },
];

const router = createRouter({
  // history: createWebHistory("/gtdesignerbeta/"),
  history: createWebHistory("/gtdesigner/"),

  routes,
});
//Route Guard to make sure we don't access the select page without a currently selected Inlay
// eslint-disable-next-line no-unused-vars
function checkInlay(to, from, next) {
  if (store.getters.currentInlay.name) {
    next();
  } else {
    next("/");
  }
}
export default router;
